const ISOtoDateOnly = (timestamp) => {
	return timestamp.split('T')[0];
};

export default ISOtoDateOnly;
